import { useEffect } from 'react';
import { useAuthStore } from '../store/useAuthStore';
import { useChatStore } from '../store/useChatStore';
import { useTurnAlertStore } from '../store/useTurnAlertStore';

export function useAppBadge() {
  const { user } = useAuthStore();
  const { chats } = useChatStore();
  const pendingHumanTurnCount = useTurnAlertStore((state) => state.pendingHumanTurnCount);

  useEffect(() => {
    if (!user) {
      if ('clearAppBadge' in navigator) {
        navigator.clearAppBadge().catch(console.error);
      }
      return;
    }

    // Calculate badge count
    // 1. Human games where a fresh opponent move made it my turn
    const myTurnGames = pendingHumanTurnCount;

    // 2. Unread chats
    const unreadChats = Object.values(chats).filter(c => c.unreadBy?.includes(user.uid)).length;

    const totalCount = myTurnGames + unreadChats;

    if ('setAppBadge' in navigator) {
      if (totalCount > 0) {
        navigator.setAppBadge(totalCount).catch(console.error);
      } else {
        navigator.clearAppBadge().catch(console.error);
      }
    }
  }, [user, pendingHumanTurnCount, chats]);
}
